// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ComboPrices_ListaVendaveisResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract de GET /so/combo_prices/lista_vendaveis/{franchise_id}
 * — so o que a franquia VENDE: combo ativo na rede com linha de preco ativa nela.
 */
import type { ComboPrices_PriceRow } from './ComboPrices_PriceRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type ComboPrices_ListaVendaveisResponseDados = ComboPrices_PriceRow[];

export type ComboPrices_ListaVendaveisResponse = ApiResponse<ComboPrices_ListaVendaveisResponseDados>;

registerResponseContract('ComboPrices_ListaVendaveisResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      so_combo_price_id:           { type: 'number',  required: true },
      so_combo_price_combo_id:     { type: 'number',  required: false },
      so_combo_price_franchise_id: { type: 'number',  required: false },
      so_combo_price_price:        { type: 'number',  required: false },
      so_combo_price_active:       { type: 'number',  required: false },
      so_combo_price_created_at:   { type: 'string',  required: false },
      so_combo_name:               { type: 'string',  required: false },
      so_combo_service_id:         { type: 'number',  required: false },
      so_combo_priority_id:        { type: 'number',  required: false },
      so_combo_quantity:           { type: 'number',  required: false },
      so_combo_validity_days:      { type: 'number',  required: false },
      so_combo_active:             { type: 'number',  required: false },
      so_service_name:             { type: 'string',  required: false },
      so_priority_name:            { type: 'string',  required: false },
    },
  },
})
